import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/(people)/people/$clientId")({
  beforeLoad: ({ params }) => {
    const { clientId } = params;

    throw redirect({ to: `/people/overview/${clientId}` });
  },
});
